import type { ChainId_L1 } from '@cronos-app/sdk';
import { ChainLayer, DEFAULT_NETWORK } from '@cronos-app/sdk';
import { Token } from '@ui/models';
import { create } from 'zustand';

import { getCardTargetToken } from './configs/token';
import type { ExtendedTokenInfo } from './types';

export const useCardContextStore = create<{
  token: ExtendedTokenInfo;
  layer: ChainLayer;
  amount: string;
  setToken: (token: ExtendedTokenInfo) => void;
  setAmount: (amount: string) => void;
  inputError: string | undefined;
  setInputError: (error: string | undefined) => void;
  setLayer: (layer: ChainLayer, network: ChainId_L1) => void;
}>((set) => ({
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  token: getCardTargetToken(DEFAULT_NETWORK, ChainLayer.L2, 'USDC')!,
  amount: '',
  layer: ChainLayer.L2,
  setToken: (token) => set({ token }),
  setAmount: (amount) => set({ amount }),
  inputError: undefined,
  setInputError: (error) => set({ inputError: error }),
  setLayer: (layer, network) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const token = getCardTargetToken(network, layer, Token.USDC)!;
    set({ layer, token });
  },
}));

export const useCardLayer = () => {
  return useCardContextStore((state) => state.layer);
};
